var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "../interceptors/api";
// Get single node by id (returns full DTO with configuration and alarm settings)
const getNodeById = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`Nodes/get-node-by-id/${id}`);
    return response;
});
// Get all nodes with pagination (returns simple DTO)
const getAllNodes = (query) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Nodes/get-all-nodes", query);
    return response;
});
// Free roaming summary — cheap count used to decide whether the sidebar item is shown.
const getFreeRoamingSummary = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get("Nodes/free-roaming-summary");
    return response;
});
// Update node (returns full DTO with configuration and alarm settings)
const updateNode = (command) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.put("Nodes/update-node", command);
    return response;
});
const appendFilterStrings = (sp, key, value) => {
    if (value === undefined || value === null)
        return;
    const list = (Array.isArray(value) ? value : [value])
        .map((s) => String(s).trim())
        .filter((s) => s.length > 0);
    list.forEach((v) => sp.append(key, v));
};
// Get nodes by access point UID with pagination
const getNodesByAccessPointUid = (accessPointUid, query) => __awaiter(void 0, void 0, void 0, function* () {
    // URLSearchParams so Filters.NodeName / Filters.NodeUid repeat for .NET List<string> binding
    const sp = new URLSearchParams();
    sp.set("pageNumber", String(query.pageNumber));
    sp.set("pageSize", String(query.pageSize));
    if (query.sortColumn)
        sp.set("sortColumn", query.sortColumn);
    if (query.sortDirection)
        sp.set("sortDirection", query.sortDirection);
    if (query.filters) {
        if (query.filters.globalSearch) {
            sp.set("Filters.GlobalSearch", query.filters.globalSearch);
        }
        if (query.filters.isActive !== undefined &&
            query.filters.isActive !== null) {
            sp.set("Filters.IsActive", String(Boolean(query.filters.isActive)));
        }
        appendFilterStrings(sp, "Filters.NodeName", query.filters.nodeName);
        appendFilterStrings(sp, "Filters.NodeUid", query.filters.nodeUid);
        if (query.filters.simulatedDisconnectedOnly === true) {
            sp.set("Filters.SimulatedDisconnectedOnly", "true");
        }
    }
    const response = yield siteX.get(`AccessPoints/${accessPointUid}/nodes`, { params: sp });
    return response;
});
// Get node temperatures (for graph, temperature logs, and event logs) with server-side pagination
const getNodeTemperatures = (nodeUid, fromDate, toDate, temperatureLogPageNumber, temperatureLogPageSize, eventLogPageNumber, eventLogPageSize) => __awaiter(void 0, void 0, void 0, function* () {
    const params = {};
    if (fromDate)
        params.fromDate = fromDate;
    if (toDate)
        params.toDate = toDate;
    if (temperatureLogPageNumber != null)
        params.temperatureLogPageNumber = temperatureLogPageNumber;
    if (temperatureLogPageSize != null)
        params.temperatureLogPageSize = temperatureLogPageSize;
    if (eventLogPageNumber != null)
        params.eventLogPageNumber = eventLogPageNumber;
    if (eventLogPageSize != null)
        params.eventLogPageSize = eventLogPageSize;
    const response = yield siteX.get(`NodesV2/get-node-temperatures/${nodeUid}`, { params });
    return response;
});
const getNodeReplacementHistoryOptions = (nodeUid, accessPointUid) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`NodesV2/replacement-history-options/${encodeURIComponent(nodeUid)}`, { params: { accessPointUid } });
    return response;
});
const replaceNodeV2 = (command) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("NodesV2/replace", command);
    return response;
});
const getReplacementCandidatesV2 = (query) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("NodesV2/replacement-candidates", query);
    return response;
});
// Get nodes dropdown by access point UID
const getNodesDropdown = (accessPointUid) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`AccessPoints/${accessPointUid}/nodes/dropdown`);
    return response;
});
// Get filter dropdowns with search
const getDropdowns = (query) => __awaiter(void 0, void 0, void 0, function* () {
    const params = {};
    if (query.nodeUidSearch) {
        params.nodeUidSearch = query.nodeUidSearch;
    }
    if (query.nodeNameSearch) {
        params.nodeNameSearch = query.nodeNameSearch;
    }
    if (query.apUidSearch) {
        params.apUidSearch = query.apUidSearch;
    }
    if (query.apNameSearch) {
        params.apNameSearch = query.apNameSearch;
    }
    const response = yield siteX.get("Nodes/dropdowns", { params });
    return response;
});
// Force connect a node to an AP
const forceConnectNode = (command) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Nodes/force-connect", command);
    return response;
});
// Force disconnect a node
const forceDisconnectNode = (command) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Nodes/force-disconnect", command);
    return response;
});
// Soft delete node
const deleteNode = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.delete(`Nodes/${id}`);
    return response;
});
const validateAlarmRecipientContact = (params, signal) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get("Nodes/validate-alarm-recipient-contact", { params, signal });
    return response;
});
export const nodesApi = {
    getNodeById,
    getAllNodes,
    getFreeRoamingSummary,
    updateNode,
    getNodesByAccessPointUid,
    getNodeTemperatures,
    getNodeReplacementHistoryOptions,
    getNodesDropdown,
    getDropdowns,
    forceConnectNode,
    forceDisconnectNode,
    deleteNode,
    replaceNodeV2,
    getReplacementCandidatesV2,
    validateAlarmRecipientContact,
};
